import classNames from 'classnames'
import React from 'react'
import { PortableTextBodyElement } from '../../utilities/blockContent'
import { Grid } from '../Grid'
import { RichTextArea } from '../PortableText/RichTextArea'

export interface FooterDisclosureProps {
  additionalClassName?: string
  body: PortableTextBodyElement[]
}

export const FooterDisclosure = ({
  additionalClassName,
  body,
}: FooterDisclosureProps) => (
  <Grid additionalClassName={additionalClassName}>
    <div
      className={classNames(
        'col-span-full pt-45 border-t border-shade-medium-dim',
        'sm:mx-120',
        'lg:col-start-2 lg:col-span-6 lg:mx-75',
        'xl:col-start-2 xl:col-span-8',
        'xxl:col-start-3 xxl:col-span-10'
      )}
    >
      <RichTextArea value={body} />
    </div>
  </Grid>
)
